export default "__VITE_ASSET__7a19515e__"